import React, { useState, useEffect, useContext } from 'react';

import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Alert,
  Badge,
  ProgressBar
} from 'react-bootstrap';

import axios from 'axios';
import FileDownload from 'js-file-download';

import { ReactSortable } from "react-sortablejs";
import { MessageModal  } from '../../components';

import Utils from '../../Utils';
import _ from 'lodash';

import { PhotoForm, QuestionForm, VideoForm, FileForm } from './../BuilderSteps';
import CustomTemplateList from './CustomTemplateList';
import AskTitle from './AskTitle';
import UserContext from './../../contexts/UserContext';

const Step3 = (props) => {

  const [stepData, setStepData] = useState(_.get(props, 'stepData', {}));

  const { userData,setPkgSize, getPkgSize} = useContext(UserContext);
  const [slideParams, setSlideParams] = useState({ show: false, pos: 0, mode: 1, type: false, data: {} }); // 0 = Add, 1 = Edit, //type=Photo,Question,Video, // data = existing data
  
  const [slides, setSlides] = useState(_.get(stepData, 'slides', []));
  const [loading, setLoading] = useState(false);
  const [manage, setManage] = useState(false);
  const [prepare, setPrepare] = useState(false);
  const [publish, setPublish] = useState(false);
  const [remove, setRemove] = useState(false);
  const [listManage, setListManage] = useState(false);
  const [isWeb, setWeb] = useState(false);
  const [flagScorm, setFlagScorm] = useState(false);
  const [message, setMessage] = useState(false);
  const [flagWeb, setFlagWeb] = useState(false);
  const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  
  
  const initializeSlide = () => {
    if (stepData.mode === 2 && slides.length == 1) {
      let idx = 0;
      setSlideParams({ ...slideParams, show: true, pos: idx + 1, mode: 1, type: slides[idx].type, data: slides[idx].data });
    }
  }

  useEffect(() => {
    initializeSlide();
    setManage(true);
  }, []);

  useEffect(() => {
    setStepData({ ...stepData, slides, folder: false });   
  }, [slides]);

  useEffect(() => {    
    props.onSlideSave(stepData);
  }, [stepData]);

  const [editTitle, setEditTitle] = useState(false);

  const changeTitle = (val) => {
    setStepData({ ...stepData, sprops: val});
    // setStepData({ ...stepData, sprops: val, folder: false });
    
    setEditTitle(false);
  }

  const prepareScorm = () => {
    
    if (stepData.sprops.title === "" || (isScormCountable() && _.get(stepData, 'sprops.pass_score', '') == '')) {
      setEditTitle(true);
      return;
    }

    setLoading('Preparing SCORM preview.. please wait..');
    setStepData({ ...stepData, folder: false });

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';

    axios.post(Utils.apiUrl('Scorm/prepare'), { scorm: _.omit(stepData, 'slides', 'step'), slides: slides }, headers).then(res => {
      setLoading(false);      
      if (res.data.success) {
        setStepData({ ...stepData, folder: res.data.folder, publishes: res.data.publishes, publishMessage: res.data.message });
        window.open(process.env.REACT_APP_API_URL + 'scorm/' + res.data.folder + '/launch.html');
      }       
      else {
        window.alert("Error occurred, Contact Admin!");
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
    setFlagScorm(true);
    setFlagWeb(false);
    setPublish(true);
  }

  const prepareWeb = () => {
    setWeb(true);
    if (stepData.sprops.title === "") {
      setEditTitle(true);
      return;
    }
    setFlagWeb(true);
    setFlagScorm(false);
    setLoading('Preparing Web preview.. please wait..');
    setStepData({ ...stepData, folder: false });

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';

    axios.post(Utils.apiUrl('Web/prepare'), { scorm: _.omit(stepData, 'slides', 'step'), slides: slides }, headers).then(res => {
      setLoading(false);
      if (res.data.success) {
        setStepData({ ...stepData, folder: res.data.folder, publishes: res.data.publishes });
        window.open(process.env.REACT_APP_API_URL + 'web/' + res.data.folder + '/slider.html');
      } else {
          window.alert('Some error occurred on server!');
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
    setPublish(true);
  }

  const downloadScorm = (id, callback) => {
    var headers = { ...Utils.apiHeaders(), "responseType": "blob" };
    axios.get(Utils.apiUrl('Scorm/download?id=' + id), headers).then((res) => {
      FileDownload(res.data, stepData.sprops.title + '_' + Date.now() + '.zip');
      setMessage(false);
      callback();
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }

  const downloadWeb = (id, callback) => {
    var headers = { ...Utils.apiHeaders(), "responseType": "blob" };
    axios.get(Utils.apiUrl('Web/download?id=' + id), headers).then((res) => {
      FileDownload(res.data, stepData.sprops.title + '_' + Date.now() + '.zip');
      setMessage(false);
      callback();
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }


  const publishScorm = () => {
    setMessage(['error',['Confirm password does not match! Password are case sensitive.']]);
    setMessage(['info', ['Please wait, We are processing your file...']]);
    setLoading('Publishing SCORM.. please wait..');
    Utils.setCourseType(false);
    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';
    let npeJson = {
      'uid'           : userData.id,
      'username'      : userData.username,
      'publishes'     : userData.publishes,
      'course-type'   : 'scorm',
      'course-size'   : getPkgSize(),
      'folder'  : ''
    }

    axios.post(Utils.apiUrl('Scorm/publish'), { folder: stepData.folder, npeJson: npeJson, scorm: _.omit(stepData, 'slides', 'step'), slides: slides, scorm_id: _.get(stepData, 'scorm_id', 0) }, headers).then(res => {
      if (res.data) {
        downloadScorm(res.data, () => {
          Utils.saveUserData(Utils.getUserData(), { step: 1 });
          setLoading(false);
          window.location.href = process.env.PUBLIC_URL + '/scorms';
        });
      } else {
        window.alert('Some error occurred on server!');
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }

  const publishWeb = () => {
    Utils.setCourseType(false);
    setLoading('Publishing WEB version.. please wait..');
    setMessage(['info', ['Please wait, We are processing your file...']]);

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';
    let npeJson = {
      'uid'           : userData.id,
      'username'      : userData.username,
      'publishes'     : userData.publishes,
      'course-type'   : 'web',
      'course-size'   : getPkgSize(),
      'folder'  : ''
    } 

    axios.post(Utils.apiUrl('Web/publish'), { folder: stepData.folder, npeJson : npeJson,  scorm: _.omit(stepData, 'slides', 'step'), slides: slides, scorm_id: _.get(stepData, 'scorm_id', 0)}, headers).then(res => {
      if (res.data) {
        downloadWeb(res.data, () => {
          Utils.saveUserData(Utils.getUserData(), { step: 1 });
          setLoading(false);
          window.location.href = process.env.PUBLIC_URL + '/scorms';
        });
      } else {
          window.alert('Some error occurred on server!');
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }

  const updateManage = () => {
    setManage(true);
    setPrepare(false);
    setPublish(false);
  }

  const updatePrepare = () => {
    if (slides.length > 0) {
      if(prepare){
        setPrepare(true);
        setSlides(slides);
        setManage(true);
        setPublish(false);
      }  
    }
  }

  const updatePublish = () => {
    if (prepare === true) {
      setPublish(true);
    }
  }

  const showManage = () => {
    setListManage(true);
  }
  const hideManage = () => {
    setListManage(false);
  }

  const renderManage = () => {
    return <div className="instructions">
      <h3 className="my-3" >
        {listManage === false && <><span className="clickable" onClick={showManage}>+ </span>Manage your slides and add more</>}
        {listManage === true && <><span className="clickable" onClick={hideManage}>- </span>Manage your slides and add more</>}
      </h3>

      {listManage && <span>
        <ol>
          <li>More slides can be added by clicking <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} alt="Add Slide" width="15" pos={0} /><strong> Add Slide</strong>.         </li>
          <li>Slides can be dragged and dropped to change the sequence.</li>
          <li>Slides can be removed by clicking <img className="remove" src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} alt="Remove Slide" /><strong> Remove Slide</strong>.</li>
          <li>Click on slide to edit them.</li>
        </ol>
      </span>}
      <Row className="changeCourseName">
        <Col>
          <Alert variant="warning">
            {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" onClick={() => setEditTitle(true)} />
          </Alert>
        </Col>
      </Row>

      <Card.Body className="card-box w-100 my-3 py-4 text-center bg-light">
        {slides.length === 0 && <Alert>
          <p>No Slide added yet!</p>
          <p>Click <span className="fa fa-plus" /> to add slide</p>
          <p><img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} alt="Add Slide" className="clickable" width="25" pos={0} onClick={addSlideHandler} /></p>
        </Alert>}
        {slides.length > 0 && <ReactSortable
          list={slides}
          setList={setSlides}
        >
          {slides.map((slide, idx) => <div key={idx} className="my-2" style={{ display: 'inline-block' }}>
            <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} className="clickable plus" pos={idx} alt="Add Slide" onClick={addSlideHandler} />
            <div className="slides" >
              <img className="remove" src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} sid={slide.sid} onClick={removeSlideHandler} alt="Remove Slide" />
              {slide.type === 'Photo' && (<>
                {_.get(slide, 'data.manual', false) === false && <img alt={`Slide ${slide.sid}`} src={Utils.apiUrl(`image?d=${stepData.fname}&f=${slide.sid}.jpg`)} sid={slide.sid} onClick={openSlideEditor} />}
                {_.get(slide, 'data.manual', false) === true && <img alt={`Slide ${slide.sid}`} src={Utils.apiUrl(`image?f=${slide.data.fname}`)} sid={slide.sid} onClick={openSlideEditor} />}
              </>)}
              {slide.type === 'Question' && <img src={`${process.env.PUBLIC_URL}/images/quiz_slide.png`} alt={`Slide ${slide.sid}`} className="p-5" sid={slide.sid} onClick={openSlideEditor} />}
              {slide.type === 'Video' && <img src={`${process.env.PUBLIC_URL}/images/video_slide.png`} alt={`Slide ${slide.sid}`} className="p-5" sid={slide.sid} onClick={openSlideEditor} />}
              {slide.type === 'Template' && <img className="img-fluid" src={`${process.env.PUBLIC_URL}/images/template-thumbnails/slide-${slide.data.template}.jpg`} alt={`Slide ${slide.sid}`} sid={slide.sid} onClick={openSlideEditor} />}
            </div>
            {idx === (slides.length - 1) && <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} className="clickable" pos={idx + 1} alt="Add Slide" onClick={addSlideHandler} />}
          </div>)}
        </ReactSortable>}
        <br /><hr />
        <Row>

          <Col className="text-center">

            Once you are done with managing slides <span className="fa fa-arrow-right mx-3" /><br /><br />
            {slides.length === 0 && <Button variant="secondary" className="px-4" style={{ "cursor": "none" }} disabled>Prepare Course</Button>}
            {slides.length > 0 && <Button className="active px-4" onClick={setPrepare}>Prepare Course</Button>}
          </Col>

        </Row>
      </Card.Body>
    </div>
  }

  const renderPrepare = () => {
    return <>
      <div className="instructions">
        <h3 className="my-3">Instructions for Prepare & Preview SCORM</h3>
        <ol>
          <li>To edit your SCORM package, click at the top button “Manage Slides”. </li>
          <li>If you are satisfied with your SCORM package, click on “Publish SCORM”.</li>
        </ol>
      </div>
      <Row className="changeCourseName">
        <Col><Alert variant="warning">
          {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" onClick={() => setEditTitle(true)} /></Alert></Col>
      </Row>

      <br />
      <Row>
        <Col className="text-center publishcta">
          {slides.length === 0 && <Button variant="secondary" className="px-4" style={{ "cursor": "none" }} disabled>Prepare & Preview SCORM</Button>}
          {(slides.length > 0 && (Utils.getCourseType() === false || Utils.getCourseType() === 'scorm')) &&
            <Button className="active px-4" onClick={prepareScorm}>Prepare & Preview SCORM</Button>}
          {(slides.length > 0 && (Utils.getCourseType() === false || Utils.getCourseType() === 'web')) &&
            <Button className="active px-4" onClick={prepareWeb}>Prepare & Preview Web</Button>}
          <br />
          Note: Allow pop-ups in your browser to Preview SCORM.<br />
        </Col>
      </Row>
    </>
  }

  const renderPublish = () => {
    return <>
      {/**Instructions section */}
      <div className="instructions">
        <h3 className="my-3">You have successfully created your SCORM.<br />Download it here.</h3>
        <ol>
          <li>Your SCORM package is ready, click on “Download your SCORM”.</li>
          <li>You can always edit your SCORM package, by clicking on “My Authoring Log” and select the package you want to revise.</li>
          {/* <li>To extend your allowed package publishes you need to buy one among our packages by clicking <strong>"Buy Now"</strong>  </li>               */}
        </ol>
      </div>
      <Row className="changeCourseName">
        <Col><Alert variant="warning">
          {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" onClick={() => setEditTitle(true)} /></Alert></Col>
      </Row>

      {/**Button section */}
      {_.get(stepData, 'folder', false) !== false &&
        <div className="text-center">
          <hr />

          {_.get(stepData, 'publishes', 0) <= 0 &&
            <> <Alert variant="warning">
              <h3 className="text-dark">To Publish and download your scorm</h3>
              {_.get(stepData, 'publishMessage', '') != '' && <Alert>{stepData.publishMessage}</Alert>}
              <a className="btn btn-primary active px-4 mt-2 py-3" href="../#buy-now">Buy Now</a>
            </Alert>
            </>
          }

          {_.get(stepData, 'publishes', 0) > 0 && <>
            <Row className="justify-content-center">
              <Alert variant="secondary" className="col-lg-8 col-sm-12" style={{ borderRadius: "30px" }}><Badge variant="warning">{stepData.publishes}</Badge> Downloads are remaining in your account </Alert>
            </Row>
            <Row>
              {console.log(flagScorm, "flags ", flagWeb)}
              {flagScorm && <Col>
                <Button className="active px-4" onClick={publishScorm}>Download your SCORM</Button>
              </Col>}
              {flagWeb && <Col>
                <Button className="active px-4" onClick={publishWeb}>Download your WEB</Button>
              </Col>}
              {message && <MessageModal type={message[0]} dwn={true} message={message[1]} onHide={() => { setMessage(false); }} />}
            </Row>
          </>}
        </div>}
    </>
  }

  const renderInfo = () => {
    return <> <Card className="noBg">
      <Card className="stepHead">
        {manage && prepare === false && publish === false && <h1>Get Started with Managing your Slides<span>1 out of 3</span></h1>}
        {prepare && publish === false && <h1>Here you can Prepare & Preview your SCORM<span>2 out of 3</span></h1>}
        {publish && <h1>Your SCORM Package is ready.<span>3 out of 3</span></h1>}
        <div className="steps">
          <ul>
            <li className={`clickable ${(manage && prepare === false && publish === false) ? 'active' : prepare || publish ? 'text-dark' : ''}`}  onClick={updateManage}>Manage Slides</li>
            <li className={`${(prepare && publish === false) ? 'active clickable ' : publish ? 'text-dark  ' : 'disable'}`} onClick={updatePrepare}>Prepare & Preview SCORM</li>
            <li className={`${publish ? 'active clickable' : 'disable'}`} onClick={updatePublish}>Publish SCORM</li>
          </ul>
        </div>
      </Card>

      <Card.Body className="card-box w-100 p-4">
      <Alert variant="success" className="p-3"><i className="fa fa-exclamation-circle" /> Your SCORM size is {getPkgSize().toFixed(1)} MB now, Max allowed is {scormsize_in_mb} MB.</Alert>
        {manage && prepare === false && publish === false && renderManage()}

        {prepare && publish === false && renderPrepare()}

        {publish && renderPublish()}

        {loading && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert></div>}
      </Card.Body>
    </Card>
      {(prepare || publish) && <><br /> <br /><br /> </>}</>
  }

  const addSlideHandler = (e) => {
    setSlideParams({ ...slideParams, show: true, pos: e.currentTarget.getAttribute('pos'), mode: 0, type: false, data: {} });
  }

  const removeSlideHandler = (e) => {
    if (window.confirm("Are you sure to delete this slide?")) {
      var tmp = [...slides];
      _.remove(tmp, s => parseInt(s.sid) === parseInt(e.currentTarget.getAttribute('sid')));
      setSlides(tmp);
      setRemove(true);
      e.stopPropagation();
      e.preventDefault();
    }

  }

  const openSlideEditor = (e) => {
    var idx = slides.findIndex(s => parseInt(s.sid) === parseInt(e.currentTarget.getAttribute('sid')));
    let src = '';
    if(slides[idx].type === 'Photo'){
      src = e.currentTarget.getAttribute('src');
    } 
    setSlideParams({ ...slideParams, show: true, pos: idx + 1, mode: 1, type: slides[idx].type, data: slides[idx].data, src:src });
  }

  const hideAdd = () => {
    setSlideParams({ ...slideParams, show: false });
  }

  const showType = (e) => {
    var btn = e.currentTarget;
    setSlideParams({ ...slideParams, type: btn.getAttribute('tname') });
  }

  const showAddDialog = () => {

    return <Modal
      show={slideParams.show}
      onHide={hideAdd}
      backdrop="static"
      keyboard={false}
      size={slideParams.type && (slideParams.type === 'Question' || slideParams.type === 'Template') ? 'xl' : 'lg'}
    >
      <Modal.Header closeButton className="slInsPop">

      </Modal.Header>

      {!slideParams.type && showSlideInstructions()}

      {slideParams.type === 'Photo' && <PhotoForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Question' && <QuestionForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Video' && <VideoForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Template' && <CustomTemplateList onSlideSave={onFinalize} {...slideParams} />}
      {slideParams.type === 'File' && <FileForm onSlideSave={onFinalize} {...slideParams} />}
    </Modal>;
  }

  const getNextSlideId = () => {
    if (slides.length > 0) {
      return parseInt(_.maxBy(slides, 'sid').sid) + 1;
    } else {
      return 1;
    }
  }

  const onFinalize = (data, type, mode = 0) => {
    var tmp = [...slides];
    if (mode) {
      tmp[parseInt(slideParams.pos) - 1]['data'] = data;
    } else {
      let slide = { sid: getNextSlideId(), type: type, data: data};
      if(tmp.length <= slideParams.pos){
       tmp.push(slide);
      }
      else{
        tmp.splice(parseInt(slideParams.pos), 0, slide);
      }
    }
    setSlides(tmp);
    setSlideParams({ ...slideParams, show: false });
  }

  const showSlideInstructions = () => {
    return <>
      <Modal.Body className="slInstruction">
        <Row className="mt-2 clickable" tname="Photo" onClick={showType}>
          <Col sm={1}>   <img src={`${process.env.PUBLIC_URL}/images/pic.png`} alt="Image" /></Col>
          <Col>Click here to upload your image.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Question" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/quizz_icon.png`} alt="Question Slide" /></Col>
          <Col>Click here to add quiz with answers.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Video" onClick={showType}>
          <Col sm={1}> <img src={`${process.env.PUBLIC_URL}/images/video.png`} alt="Video" /></Col>
          <Col>Click here to upload video.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Template" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/custom_slide.png`} alt="Custom Slide" /></Col>
          <Col>Click here to add customized templates.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="File" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/pdf-ppt.png`} alt="Custom Slide" /></Col>
          <Col>Click here to add pdf/ppt file</Col>
        </Row>
      </Modal.Body>
    </>;
  }


  const isScormCountable = () => {
    return slides.findIndex(s => s.type === "Question" && s.data.countable) > -1;
  }

  return <>
    {renderInfo()}
    {showAddDialog()}

    {editTitle && <AskTitle data={stepData} onHide={() => setEditTitle(false)} onSuccess={changeTitle} countable={isScormCountable()} />}
  </>;
}

export default Step3;